import React, { useState } from "react";
import { useMap, useMapsLibrary } from "@vis.gl/react-google-maps";
import { useEffect } from "react";

export default function DrawLocations({
  onAdd,
  drawingModes,
}: {
  onAdd: (overlay: any) => void;
  drawingModes?: ("marker" | "polygon" | "rectangle")[];
}) {
  const map = useMap();
  const drawing = useMapsLibrary("drawing");

  useEffect(() => {
    if (!map || !drawing) return;

    // https://developers.google.com/maps/documentation/javascript/reference/drawing
    const newDrawingManager = new drawing.DrawingManager({
      map,
      drawingMode: null,
      drawingControl: true,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER,
        drawingModes: drawingModes
          ? [
              ...(drawingModes.includes("marker")
                ? [google.maps.drawing.OverlayType.MARKER]
                : []),
              ...(drawingModes.includes("polygon")
                ? [google.maps.drawing.OverlayType.POLYGON]
                : []),
              ...(drawingModes.includes("rectangle")
                ? [google.maps.drawing.OverlayType.RECTANGLE]
                : []),
            ]
          : [
              google.maps.drawing.OverlayType.MARKER,
              google.maps.drawing.OverlayType.POLYGON,
              google.maps.drawing.OverlayType.RECTANGLE,
            ],
      },
      markerOptions: {
        draggable: true,
      },

      polygonOptions: {
        editable: true,
        draggable: true,
      },
      rectangleOptions: {
        editable: true,
        draggable: true,
      },
    });

    newDrawingManager.addListener("overlaycomplete", (event: any) => {
      newDrawingManager.setDrawingMode(null);
      onAdd(event.overlay);
    });

    return () => {
      newDrawingManager.setMap(null);
    };
  }, [drawing, map]);

  return <></>;
}
